import { Chip, styled, Theme } from '@mui/material';

export const NotificationChip = styled(Chip)(({ theme }) => ({
  fontSize: theme.typography.body3.fontSize,
  height: '20px',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  '& .MuiChip-label': {
    padding: theme.spacing(0, 1),
  },
}));

export const menuItemStyles = (theme: Theme) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  fontFamily: theme.typography.fontFamily,
  color: theme.palette.text.primary,
  fontSize: theme.typography.subtitle.fontSize,
  fontStyle: 'normal',
  fontWeight: theme.typography.fontWeightRegular,
  lineHeight: '28px',
});
